export const LOGIN = 'login'
export const REGISTER = 'register'
export const PRICING = 'pricing'
export const DASHBOARD = 'dashboard'
export const DASHBOARD_COMPETITORS_TRACKING_ID =
  'dashboard/competitor_tracking/:projectId'
export const FORGOT_PASSWORD = 'forgot-password'
export const EXTENSION = 'extension'
export const SEO_ANALYZER_SITE_AUDIT = 'seo_analyzer/site_audit'
export const UBERSUGGEST_OVERVIEW = 'ubersuggest/overview'
export const UBERSUGGEST_KEYWORD_IDEAS = 'ubersuggest/keyword_ideas'
export const UBERSUGGEST_KEYWORD_VISUALIZATION =
  'ubersuggest/keyword_visualization'
export const TRAFFIC_ANALYZER_KEYWORDS = 'traffic_analyzer/keywords'
export const TRAFFIC_ANALYZER_COMPETITORS = 'traffic_analyzer/competitors'
export const UBERSUGGEST_CONTENT_IDEAS = 'ubersuggest/content_ideas'
export const UBERSUGGEST_KEYWORD_LISTS = 'ubersuggest/keyword_lists'
export const TRAFFIC_ANALYZER_OVERVIEW = 'traffic_analyzer/overview'
export const TRAFFIC_ANALYZER_TOP_PAGES = 'traffic_analyzer/top_pages'
export const SEO_ANALYZER_BACKLINKS = 'seo_analyzer/backlinks'
export const SEO_ANALYZER_BACKLINK_OPPORTUNITY =
  'seo_analyzer/backlink_opportunity'
export const LABS_LANDING = 'labs/landing'
export const LABS_KEYWORDS_GENERATOR = 'labs/keywords_generator'
export const ALERTS = 'alerts'
export const ALERTS_ID = 'alerts/:id'
export const CHANGE_PASSWORD = 'change-password'
export const CHECKOUT = 'checkout'
export const WORKSPACE = 'workspace'
export const SEO_OPPORTUNITIES = 'seo_opportunities'
export const SETTINGS = 'settings'
export const SETTINGS_ID = 'settings/:page'
export const POSITION_TRACKING = 'position_tracking'
export const POSITION_TRACKING_ID = 'position_tracking/:projectId'
export const KEYWORD_LISTS = 'keyword_lists/'
export const KEYWORD_LISTS_ID = 'keyword_lists/:id'
export const STATIC = 'static'
export const VERIFY_EMAIL = 'verify-email'
export const ENTERPRISE_DASHBOARD = 'enterprise/dashboard'
